// 旧站点保持原有第三方广告/支付埋点，不新增 App 口径事件。
export const legacyPayment: typeof import('./superstory/payment') = {
  rememberCheckout: () => '',
  orderCreated: () => {},
  paymentConfirmed: () => {},
  paymentFailed: () => {},
}
